module.exports = __webpack_public_path__ + "static/media/contract_uav_gc.97239c3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contract_uav_gc.svg
// module id = 256
// module chunks = 0